<template>
  <div v-if="contactData !==null" class="w-full bg-white pb-16 tab-content mt-6">
    <div
      class="font-medium text-lg px-4 py-8  flex item-center justify-between border-b"
    >
      <h2>{{ $t('message.selfService.infoEmployee.contactInfo.contact') }}</h2>
      
    </div>
     <div
      class="font-normal px-4 pt-2  flex item-center justify-between"
    >
      <h2>{{ $t('message.selfService.infoEmployee.contactInfo.personal') }}</h2>
      
    </div>
     <div class="px-4">
      <div class="flex flex-wrap md:flex-no-wrap">
        <div class="w-full md:w-1/2 mr-8 custom-input mt-10 relative">
          <zt-input
            v-model="contactData.telephone_cel"
            readonly
            outlined
            name="cellphone"
            class="w-full"
            :label="$t('message.selfService.infoEmployee.contactInfo.cellphone')"
            data-vs-input="contact-person"
          />
        </div>
        <div class="w-full md:w-1/2 mr-4 custom-input mt-10 relative">
          <zt-input
            v-model="contactData.telephone"
            readonly
            outlined
            color="primary"
            name="personalPhone"
            class="w-full text-zt-lg"
            :label="$t('message.selfService.infoEmployee.contactInfo.personalPhone')"
            data-vs-input="personal-phone"
          />
        </div>
      </div>
     </div>
        <div
      class="font-normal px-4 pt-6 flex item-center justify-between"
    >
      <h2>{{ $t('message.selfService.infoEmployee.contactInfo.emergencyData') }}</h2>
      
    </div>
     <div class="px-4">
      <div class="flex flex-wrap md:flex-no-wrap">
        <div class="w-full md:w-1/2 mt-10 mr-4 custom-input relative flex-wrap ">
          <zt-input
            v-model="contactData.telephone_emergency"
             readonly
             outlined
            name="emergencyPhone"
            class="w-full"
            :label="$t('message.selfService.infoEmployee.contactInfo.telephone_emergency')"
            data-vs-input="emergency-phone"
          />
         
        </div>
         <div class="w-full md:w-1/2 mr-4 custom-input mt-10 relative">
          <zt-input
            v-model="contactData.name_contact_emergency"
            readonly
            outlined
            name="contactPerson"
            class="w-full"
            :label="$t('message.selfService.infoEmployee.contactInfo.contactPerson')"
            data-vs-input="contact-person"
          />
        </div>
      </div>
    </div>
    <div class="px-4">
      <div class="flex flex-wrap md:flex-no-wrap mr-16">
        <div class="w-full md:w-1/2 mt-10 mr-4 custom-input relative flex-wrap ">
          <zt-input
            v-model="contactData.type_contact"
             readonly
             outlined
            name="contactType"
            class="w-full"
            :label="$t('message.selfService.infoEmployee.contactInfo.contactType')"
            data-vs-input="contactType"
          />
         
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="w-full md:w-2/3 m-6 py-6">
      <zt-alert color="info" filled :closeIcon="false">
        <template slot="custom-content">
          <div class="flex justify-start items-center">
            <zt-icon name="info-circle-solid" class="text-2xl mr-4"></zt-icon>
            <p>{{ $t('message.selfService.infoEmployee.tab.emptyTab') }}</p>
          </div>
        </template>
      </zt-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserContactInfo',
  props: {
    contactData: { type: Object }
  },
}
</script>

<style scoped lang="scss">
.tab-content {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
</style>
